/**
 * Handicrafts and Souvenirs Section Component
 * Displays handicrafts and souvenirs in a vertical list layout
 * Follows Single Responsibility Principle - only responsible for rendering the section with items
 */

import React from 'react';
import { spacing } from '@/design-system/utils';
import { SectionHeader } from '@/components/ui/section-header';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { HandicraftList } from './HandicraftList';
import { HandicraftsAndSouvenirsSectionProps } from './types';

/**
 * Handicrafts and Souvenirs Section Component
 * Renders a vertical list of handicraft/souvenir items with responsive layout
 */
export const HandicraftsAndSouvenirsSection: React.FC<
  HandicraftsAndSouvenirsSectionProps
> = ({ title = 'Handicrafts and Souvenirs', items, className, placeName }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[3],
      }}
      className={className}
    >
      <SectionHeader title={title} />
      <HandicraftList items={items} placeName={placeName} isMobile={isMobile} />
    </div>
  );
};
